import { INTERNAL_PATHS } from "./paths";

/**
 * Paths routed to raise-web-www-gift-card-exchange in gcx-staging HTTPRoute.
 * Client-side navigation on GCX domains must stay in-app only for these paths;
 * all other paths hard-reload so the gateway can route to the correct backend.
 *
 * @see infrastructure-manifests/routes/gcx-staging.yaml
 */
const GCX_INTERNAL_EXACT_PATHS = new Set([
  INTERNAL_PATHS.HOME,
  INTERNAL_PATHS.SECRET_HOME,
  INTERNAL_PATHS.CART,
  INTERNAL_PATHS.GIFT_CARD_BALANCE,
  INTERNAL_PATHS.HOW_IT_WORKS,
  INTERNAL_PATHS.PRIVACY_POLICY,
  INTERNAL_PATHS.REFERRAL_PROGRAM,
  INTERNAL_PATHS.PARTNER_PROGRAM,
  INTERNAL_PATHS.FTC_DISCLOSURE,
  INTERNAL_PATHS.GUARANTEE,
  INTERNAL_PATHS.SHIPPING_POLICY,
  INTERNAL_PATHS.BRAND_RESTRICTIONS,
  INTERNAL_PATHS.PRESS
]);

const GCX_INTERNAL_PREFIX_PATHS = [
  `${INTERNAL_PATHS.SECRET_HOME}/`,
  `${INTERNAL_PATHS.CART}/`,
  `${INTERNAL_PATHS.GIFT_CARD_BALANCE}/`,
  `${INTERNAL_PATHS.HOW_IT_WORKS}/`,
  `${INTERNAL_PATHS.PRIVACY_POLICY}/`,
  `${INTERNAL_PATHS.REFERRAL_PROGRAM}/`,
  `${INTERNAL_PATHS.PARTNER_PROGRAM}/`,
  `${INTERNAL_PATHS.FTC_DISCLOSURE}/`,
  `${INTERNAL_PATHS.GUARANTEE}/`,
  `${INTERNAL_PATHS.SHIPPING_POLICY}/`,
  `${INTERNAL_PATHS.BRAND_RESTRICTIONS}/`,
  `${INTERNAL_PATHS.PRESS}/`
];

export const getPathnameFromNavigateTarget = (url) => {
  if (!url || typeof url !== "string") {
    return "";
  }

  if (/^https?:\/\//i.test(url)) {
    try {
      return new URL(url).pathname;
    } catch {
      return "";
    }
  }

  return url.split("?")[0].split("#")[0];
};

const isGiftCardExchangeInternalPath = (pathname) => {
  if (GCX_INTERNAL_EXACT_PATHS.has(pathname)) {
    return true;
  }

  return GCX_INTERNAL_PREFIX_PATHS.some((prefix) =>
    pathname.startsWith(prefix)
  );
};

export const isStorefrontOnlyPath = (url) => {
  const pathname = getPathnameFromNavigateTarget(url);

  if (!pathname) {
    return false;
  }

  return !isGiftCardExchangeInternalPath(pathname);
};
